import service from '@/utils/request'

// 登录接口
export const useLoginApi = (data: any) => {
	return service.post('/admin/login', data)
}

// 手机号登录接口
export const useLoginApiPhone = (data: any) => {
	return service.post('/api/client/login', data)
}

// 登出接口
export const useLogoutApi = () => {
	return service.post('/admin/logout')
}
// 登出接口（客户端）
export const clientLogoutApi = () => {
	return service.post('/api/client/logout')
}

// 发送验证码
export const useSendCode = (data: any) => {
	return service.post('/admin/sms_code', data)
}
